"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToCtrlKeyIsDown = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var is_ctrl_key_1 = require("../../is-ctrl-key");
var mapToCtrlKeyIsDown = function () { return function (keyEvents$) {
    return keyEvents$.pipe((0, operators_1.filter)(function (_a) {
        var _b = tslib_1.__read(_a, 2), _du = _b[0], ev = _b[1];
        return (0, is_ctrl_key_1.isCtrlKey)(ev);
    }), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 1), du = _b[0];
        return du === 'down';
    }));
}; };
exports.mapToCtrlKeyIsDown = mapToCtrlKeyIsDown;
